import { Container } from "react-bootstrap";
import ArtisticDirectionComponents from "../../direction_artistic_components/direction_artistic/components/direction_artistic_components";

const ArtisticDirection = () => {
  return (
    <Container fluid className="p-0 m-0 header_white">
      <ArtisticDirectionComponents />
    </Container>
  );
};
export default ArtisticDirection;
